export class UserInfo {
    id:string= "";
    user_id: string= "";
    first_name: string= "";
    last_name:string= "";
    mobile:string= "";
    phone:string= "";
    support_email:string= "";

  }